import { render, staticRenderFns } from "./CreatePointeCohort.vue?vue&type=template&id=4017944e&scoped=true"
import script from "./CreatePointeCohort.vue?vue&type=script&lang=js"
export * from "./CreatePointeCohort.vue?vue&type=script&lang=js"
import style0 from "./CreatePointeCohort.vue?vue&type=style&index=0&id=4017944e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017944e",
  null
  
)

export default component.exports